export default __webpack_public_path__ + "static/media/CNo.34-2.93d3dd1b.jpg";